import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'timeAgo',
  standalone: true
})
export class TimeAgoPipe implements PipeTransform {
  transform(value: Date): string {
    const date = this.parseToValidDate(value);

    if (!date) {
      return '';
    }
    const now = new Date();
    const seconds = Math.floor((now.getTime() - date.getTime()) / 1000);

    if (seconds === 0) {
      return 'Now';
    } else if (seconds < 60) {
      return `${seconds} seconds ago`;
    } else if (seconds < 3600) {
      const minutes = Math.floor(seconds / 60);
      return `${minutes} minutes ago`;
    } else if (seconds < 86400) {
      const hours = Math.floor(seconds / 3600);
      return `${hours} hours ago`;
    } else {
      const options: Intl.DateTimeFormatOptions = { month: 'long', day: 'numeric', year: 'numeric' };
      return date.toLocaleDateString('en-IE', options).replace(/,/g, '');
    }
  }

  private parseToValidDate(value: any): Date | null {
    if (value instanceof Date) {
      return !isNaN(value.getTime()) ? value : null;
    }

    if (typeof value === 'string' && value.trim() !== '') {
      const date = new Date(value);

      if (!isNaN(date.getTime())) {
        return date;
      }
    }

    return null;
  }
}
